module.exports = __webpack_public_path__ + "img/ic-energy-grey.c20482e9.svg";